var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { ThemeUtils, getAttributes } from '../../../../../utils';
import { Button, ButtonWidths } from '../../../../atoms/button';
import { Select } from '../../../../molecules/select';
import { Container, ContainerDisplays, ContainerFlexGaps } from '../../../../templates/container';
var ATC = function (_a) {
    var props = __rest(_a, []);
    var id = props.id, buttonLabel = props.buttonLabel, disabledButton = props.disabledButton, loadingButton = props.loadingButton, buttonWidth = props.buttonWidth, buttonVariant = props.buttonVariant, qtySelectorProps = props.qtySelectorProps, onButtonClick = props.onButtonClick, onQTYChange = props.onQTYChange, rest = __rest(props, ["id", "buttonLabel", "disabledButton", "loadingButton", "buttonWidth", "buttonVariant", "qtySelectorProps", "onButtonClick", "onQTYChange"]);
    var _b = React.useState(qtySelectorProps === null || qtySelectorProps === void 0 ? void 0 : qtySelectorProps.defaultQTYValue), qtyValue = _b[0], setQTYValue = _b[1];
    var qtyChange = function (event) {
        setQTYValue(event.target.value);
        onQTYChange === null || onQTYChange === void 0 ? void 0 : onQTYChange(event);
    };
    var qtySelectorConfig = __assign({ menuItems: qtySelectorProps === null || qtySelectorProps === void 0 ? void 0 : qtySelectorProps.orderQTY, fullWidth: false, value: qtyValue, onChange: qtyChange, disableScrollLock: true }, (qtySelectorProps ? __assign({}, getAttributes(qtySelectorProps)) : {}));
    var atcButtonConfig = __assign({ id: id, onClick: onButtonClick, label: buttonLabel, disable: disabledButton, loading: loadingButton }, getAttributes(rest));
    var atcButtonMobileConfig = __assign(__assign({}, atcButtonConfig), { buttonVariant: buttonVariant, buttonWidth: buttonWidth ||
            ThemeUtils.getResponsiveProp([
                ButtonWidths.Full,
                ButtonWidths.Full,
                ButtonWidths.Auto
            ]) });
    var wrapperConfig = {
        display: ContainerDisplays.Flex,
        flexGap: ContainerFlexGaps.Size_4
    };
    return (React.createElement(Container, __assign({}, wrapperConfig),
        (qtySelectorProps === null || qtySelectorProps === void 0 ? void 0 : qtySelectorProps.orderQTY) && (qtySelectorProps === null || qtySelectorProps === void 0 ? void 0 : qtySelectorProps.orderQTY.length) > 0 && (React.createElement(Select, __assign({}, qtySelectorConfig))),
        React.createElement(Button, __assign({}, atcButtonMobileConfig))));
};
export { ATC as AddToCart };
